import axios from 'axios';
import { Label, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

function ShopSelection() {

  const [newShopData, setNewShopData] = useState({})
  const [allShops, setAllShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // userDatail  for API request
  const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

  // user token for API request
  const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

  useEffect(() => {
    if (userDetail == undefined || userDetail && userDetail.userRole !== "Admin") {
      navigate("/buying-currency");
    }
  }, [])

  useEffect(() => {
    if (userDetail && userDetail.userRole !== "Admin") {
      return;
    }
    const fetchShops = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `getShops`, {
          params: {
            userId: userDetail?._id
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const shops = response.data;
        setAllShops(shops);

      } catch (error) {
        console.log(error);
      }
    };
    fetchShops();
  }, [])

  const handleSelectShop = async () => {
    if (selectedShop) {
      const auth = JSON.parse(localStorage.getItem("auth"));
      if (auth && auth.user) {
        auth.user.shopId = selectedShop;
        localStorage.setItem("auth", JSON.stringify(auth));
      }

      navigate(-1);
    }
  };

  const createNewShop = async () => {
    try {
      setIsLoading(true)
      const response = await axios.post(process.env.REACT_APP_API_URL + 'addShop', newShopData, {
        params: {
          userId: userDetail?._id
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.status === 201) {
        toast.success('Shop Created Successfully.');
        const auth = JSON.parse(localStorage.getItem("auth"));
        if (auth && auth.user) {
          auth.user.shopId = response.data._id;
          localStorage.setItem("auth", JSON.stringify(auth));
        }
        navigate(-1);
      }
      setIsLoading(false)

    } catch (error) {
      toast.error('Error: Shop Not Created.');
      setIsLoading(false)
    }

  }

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      {allShops && allShops.length > 0 ? (
        <div className="bg-white shadow-lg rounded-xl p-8 border border-gray-200">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Select a Shop</h1>
            <p className="text-gray-500 mt-1">Choose the shop you want to work with from the list below.</p>
          </div>

          <div className="mb-6">
            <label htmlFor="shopSelect" className="block mb-2 text-sm font-medium text-gray-700">
              Shop List
            </label>
            <select
              id="shopSelect"
              defaultValue={selectedShop}
              onChange={(e) => setSelectedShop(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="" disabled>Select a Shop</option>
              {allShops && allShops.map((shop) => (
                <option key={shop._id} value={shop._id}>{shop.name}</option>
              ))}
            </select>
            {/* <input
            id="shopPassword"
            type='password'
            placeholder='Enter Shop Password'
            className="w-full p-3 mt-5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
          </input> */}
          </div>

          <div className="text-right">
            <button
              onClick={() => handleSelectShop()}
              className="bg-[#064181] hover:bg-blue-700 transition text-white px-6 py-2 rounded-md"
            >
              Continue
            </button>
          </div>
        </div>
      ) : (
        <div className="flex max-w-md flex-col gap-4 mx-auto ml-[5rem] mt-[-5rem]" >
          <div className="mb-10">
            <h2 className="text-center text-[#063A73] font-bold text-[2rem] mt-5">Add Shop</h2>
          </div>

          <div>
            <div className="mb-2 block">
              <Label htmlFor="shopName" value="Shop Name" />
            </div>
            <TextInput
              name="shopName"
              type="text"
              placeholder="Enter Your Shop Name"
              // value={name}
              onChange={(e) => setNewShopData({
                ...newShopData, [e.target.name]: e.target.value
              })}
              required
              shadow
            />
          </div>

          <div>
            <div className="mb-2 block">
              <Label htmlFor="address" value="Address" />
            </div>
            <TextInput
              name="shopAddress"
              type="text"
              placeholder="Enter Shop Address"
              // value={email}
              onChange={(e) => setNewShopData({
                ...newShopData, [e.target.name]: e.target.value
              })}
              required
              shadow
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="shopCountry" value="Country" />
            </div>
            <TextInput
              name="shopCountry"
              type="text"
              placeholder="Enter Shop's Country"
              // value={email}
              onChange={(e) => setNewShopData({
                ...newShopData, [e.target.name]: e.target.value
              })}
              required
              shadow
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="shopCurrency" value="Currency" />
            </div>
            <TextInput
              name="shopCurrency"
              type="text"
              placeholder="Enter Shop's Currency"
              onChange={(e) => setNewShopData({
                ...newShopData, [e.target.name]: e.target.value
              })}
              required
              shadow
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="abn" value="ABN" />
            </div>
            <TextInput
              name="abn"
              type="text"
              placeholder="Enter Shop's ABN"
              onChange={(e) => setNewShopData({
                ...newShopData, [e.target.name]: e.target.value
              })}
              required
              shadow
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="phone" value="Phone" />
            </div>
            <TextInput
              name="phone"
              type="tel"
              placeholder="Enter Shop's Phone Number"
              onChange={(e) => setNewShopData({
                ...newShopData, [e.target.name]: e.target.value
              })}
              required
              shadow
            />
          </div>

          <button
            onClick={createNewShop}
            disabled={!newShopData.shopName || !newShopData.shopAddress || !newShopData.shopCurrency || !newShopData.shopCountry || !newShopData.abn || !newShopData.phone}
            // disabled={!newShopData.shopName || !newShopData.shopAddress || !newShopData.shopCurrency || !newShopData.shopCountry || !newShopData.password || !newShopData.confirmPassword || newShopData.password !== newShopData.confirmPassword}
            className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white py-2 rounded-lg"
          >
            Create
          </button>
        </div>
      )}

    </div>
  );
}

export default ShopSelection